import { render, staticRenderFns } from "./sub-task-detail.vue?vue&type=template&id=710a3181&"
import script from "./sub-task-detail.vue?vue&type=script&lang=js&"
export * from "./sub-task-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('710a3181')) {
      api.createRecord('710a3181', component.options)
    } else {
      api.reload('710a3181', component.options)
    }
    module.hot.accept("./sub-task-detail.vue?vue&type=template&id=710a3181&", function () {
      api.rerender('710a3181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/sub-task-detail.vue"
export default component.exports